function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/g, '')
}

function resolveRuntimeHostname(): string | null {
  if (typeof window === 'undefined') {
    return null
  }

  const hostname = window.location.hostname.trim()
  return hostname ? hostname : null
}

function resolveRuntimeProtocol(): string | null {
  if (typeof window === 'undefined') {
    return null
  }

  const protocol = window.location.protocol.trim().toLowerCase()
  return protocol === 'http:' || protocol === 'https:' ? protocol : null
}

export function resolveApiBaseUrl(
  input: string | undefined,
  fallback: string,
  buildMode: string | undefined = import.meta.env?.MODE,
): string {
  if (import.meta.env?.MODE === 'staging' || buildMode === 'staging')
    return resolveRuntimeHostname() === 'v4-admin-test.hoppla.be' &&
      input === 'https://v4-api-test.hoppla.be/api/v1' ? input : ''
  if (resolveRuntimeHostname() === 'v4-admin-test.hoppla.be')
    return input === 'https://v4-api-test.hoppla.be/api/v1' ? input : ''
  const raw = String(input ?? fallback).trim()

  if (!raw) {
    return trimTrailingSlash(fallback)
  }

  try {
    const url = new URL(raw)

    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return trimTrailingSlash(fallback)
    }

    if (url.hostname === 'localhost' || url.hostname === '127.0.0.1') {
      const runtimeHostname = resolveRuntimeHostname()

      if (runtimeHostname) {
        url.hostname = runtimeHostname
      }
    }

    const runtimeProtocol = resolveRuntimeProtocol()
    if (runtimeProtocol === 'https:' && url.protocol === 'http:') {
      url.protocol = 'https:'
    }

    return trimTrailingSlash(url.toString())
  } catch {
    return trimTrailingSlash(fallback)
  }
}
